export default function Edit({ className }) {
    return (
      <svg className={className} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.5351 3.63679C13.9256 3.24627 14.5588 3.24627 14.9493 3.63679L16.3635 5.05101C16.754 5.44153 16.754 6.0747 16.3635 6.46522L14.9493 7.87943L12.1209 5.05101L13.5351 3.63679Z"
              fill="#203B3F" />
        <path d="M11.4141 5.75781L14.2425 8.58624L7.17142 15.6573H4.34299V12.8289L11.4141 5.75781Z" fill="#203B3F" />
      </svg>
    )
}
